<template>
  <div class="cont_h">
    <div class="cont_heads">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="cont_tab">
        <el-breadcrumb-item :to="{ path: '/when' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>业务详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 内容部分 -->
    <div class="cont_cont">
      <!-- 顶部 -->
      <div class="cont_content">
        <h2 class="cont_text">当票详情：</h2>
      </div>
      <!-- 内容详情 -->
      <div class="conts_con">
        <div class="cont_head">
          <h3>票号:{{ items.ticketnumber }}</h3>
          <span>
            <h2>当票详情</h2>
            <el-button type="info" plain size="mini" class="btn" @click="dialogTab"
              >典当记录</el-button
            >
          </span>

          <h3>建档日期:{{ items.deta }}</h3>
        </div>

        <div class="cont_hes">
          <div class="con_os">
            <table width="100%">
              <tr>
                <td width="20%">
                  <h3>当户</h3>
                </td>
                <td width="30%">{{ items.name }}</td>
                <td width="20%"><h3>电话</h3></td>
                <td width="30%">{{ items.telnumber }}</td>
              </tr>
              <tr>
                <td>
                  <h3>地址</h3>
                </td>
                <td>{{ items.address }}</td>
                <td><h3>物品类型</h3></td>
                <td>{{ items.itemname }}</td>
              </tr>
              <tr>
                <td>
                  <h3>证件类型</h3>
                </td>
                <td>{{ items.type }}</td>
                <td><h3>证件号码</h3></td>
                <td>{{ items.cardnumber }}</td>
              </tr>
            </table>
          </div>

          <div class="con_os">
            <table width="100%">
              <tr>
                <td><h3>当物名称</h3></td>
                <td><h3>规格与状况</h3></td>
                <td><h3>数量</h3></td>
                <td><h3>重量/g</h3></td>
                <td width="15%"><h3>上交所价格/元</h3></td>
                <td width="15%"><h3>典当单价/元</h3></td>
                <td width="10%"><h3>折当率/%</h3></td>
                <td width="15%"><h3>典当金额/元</h3></td>
              </tr>
              <tr>
                <td>{{ items.objname }}</td>
                <td>{{ items.speci }}</td>
                <td>{{ items.num || items.number }}</td>
                <td>{{ items.weig || items.weight }}</td>
                <td>{{ items.realpricea }}</td>
                <td>
                  {{
                    items.unitpricea !== "计算中..."
                      ? items.unitpricea || (items.price / items.weight).toFixed(2)
                      : "无"
                  }}
                </td>
                <td>{{ items.rate || "未填写" }}</td>
                <td>{{ items.pric || items.price }}</td>
              </tr>
              <tr>
                <td>{{ items.objnamea }}</td>
                <td>{{ items.specia }}</td>
                <td>{{ items.numa }}</td>
                <td>{{ items.weiga }}</td>
                <td>{{ items.realpriceaa }}</td>
                <td>{{ items.unitpriceaa !== "计算中..." ? items.unitpriceaa : "" }}</td>
                <td>{{ items.ratea }}</td>
                <td>{{ items.prica }}</td>
              </tr>
              <tr>
                <td>{{ items.objnameaa }}</td>
                <td>{{ items.speciaa }}</td>
                <td>{{ items.numaa }}</td>
                <td>{{ items.weigaa }}</td>
                <td>{{ items.realpriceaaa }}</td>
                <td>
                  {{ items.unitpriceaaa !== "计算中..." ? items.unitpriceaaa : "" }}
                </td>
                <td>{{ items.rateaa }}</td>
                <td>{{ items.pricaa }}</td>
              </tr>
            </table>
          </div>

          <div class="con_os">
            <table width="100%">
              <tr>
                <td width="15%"><h3>开始日期</h3></td>
                <td>{{ items.startdate }}</td>
                <td width="15%"><h3>到期日期</h3></td>
                <td>{{ items.enddate }}</td>
                <td width="15%"><h3>典当天数</h3></td>
                <td width="10%">{{ items.days + "天" }}</td>
              </tr>
            </table>
          </div>
          <div class="con_os">
            <table width="100%">
              <tr>
                <td>
                  <h3>数量：{{ items.number }}</h3>
                </td>
                <td>
                  <h3>重量：{{ items.weight + "g" }}</h3>
                </td>
                <td>
                  <h3>典当价格：{{ items.price + "元" }}</h3>
                </td>
                <td>
                  <h3>典当综合费：{{ items.cost + "元" }}</h3>
                </td>
                <td>
                  <h3>典当利息：{{ items.lx == undefined ? "0" : items.lx + "元" }}</h3>
                </td>
                <td>
                  <h3>支付方式：{{ items.mode }}</h3>
                </td>
              </tr>
            </table>
          </div>
          <div class="con_os">
            <table width="100%">
              <tr>
                <td width="15%">评估意见/备注</td>
                <td>
                  <el-input class="pgu_inpt" v-model="opinion" @change="oblur"></el-input>
                </td>
              </tr>
            </table>
          </div>
          <div class="con_xs">
            <h3>历史累计逾期天数：{{ ytdy }}天</h3>
            <h3>支付积分：{{ integral }}</h3>
            <h3>典当会员：{{ openids }}</h3>
          </div>

          <div class="con_tw">
            <h3>
              图片：
              <el-button type="primary" @click="ViewImage(items.ticketnumber, '当票')"
                >查看当票</el-button
              >
              <el-button type="primary" @click="ViewImage(items.ticketnumber, '物品')"
                >查看物品</el-button
              >
              <el-button type="primary" @click="ViewImage(items.ticketnumber, '检测')"
                >检测图片</el-button
              >
              <el-button
                type="primary"
                @click="ViewImage(items.ticketnumber, '身份证正面')"
                >身份证正面</el-button
              >
              <el-button
                type="primary"
                @click="ViewImage(items.ticketnumber, '身份证反面')"
                >身份证反面</el-button
              >
              <el-button type="primary" @click="ViewImage(items.ticketnumber, '签约材料')"
                >签约材料</el-button
              >
            </h3>

            <!-- <div class="demo-image__preview">
              <image
                style="width: 600px; height: 450px"
                :src="items.reviewImg"
                @click="dialog(items.reviewImg)"
              >
              </image>
              <image
                style="width: 600px; height: 450px"
                :src="items.reviewImgs"
                @click="dialog(items.reviewImgs)"
              >
              </image>
            </div> -->
            <!-- <el-dialog :visible.sync="dialogVisibleImage">
              当票:
              <img width="100%" :src="dialogVisibleDatas.imag" alt="" />
              当物：
               <img width="100%" :src="dialogVisibleDatas.imags" alt="" />
               检测：
                <img width="100%" :src="dialogVisibleDatas.reportImage" alt="" />
            </el-dialog> -->

            <el-dialog :visible.sync="dialogVisible" :before-close="handleCloseView">
              <h3>{{ explain }}</h3>
              <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
          </div>
        </div>
        <!-- 复核 -->
        <div class="con_fu">
          <h3>经办人：{{ items.agent }}</h3>
          <h3>复核：{{ items.review }}</h3>
          <h3>财务：{{ items.finance }}</h3>
        </div>
      </div>
      <!-- 弹窗显示续当记录 -->
      <el-dialog title="典当记录：" :visible.sync="dialogTableVisible" width="70%">
        <!-- 续当成功订单 -->
        <el-table :data="xudata" border style="width: 100%">
          <el-table-column fixed="left" label="操作" width="200">
            <template slot-scope="scope">
              <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">打印续当凭证</el-button> -->
              <el-button @click="xNumber(scope.row)" type="text" size="small"
                >打印续当凭证</el-button
              >
              <el-button @click="PrintTicket(scope.row)" type="text" size="small"
                >打印收据</el-button
              >
              <el-button @click="LookVoucher(scope.row)" type="text" size="small"
                >查看电子凭证</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="stas"
            label="操作状态"
            width="80"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xuday"
            label="操作日期"
            width="100"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="ticketnumber"
            label="票号"
            width="110"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xnumber"
            label="续当票号"
            width="110"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            width="80"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="itemname"
            label="物品名称"
            width="150"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="overdate"
            label="开始日期"
            width="120"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="enddate"
            label="到期日期"
            width="120"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="dday"
            label="典当/续当天数"
            width="100"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="pri"
            label="典当金额"
            width="100"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xupri"
            label="典当综合费"
            width="100"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="lx"
            label="典当利息"
            width="100"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="ytdy"
            label="逾期天数"
            width="100"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="pena"
            label="逾期罚息"
            width="100"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="rece"
            label="实付金额"
            width="110"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="couqons"
            label="优惠券"
            width="110"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="couqonmoney"
            label="优惠金额"
            width="110"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xuname"
            label="操作人"
            width="140"
            header-align="center"
            align="center"
          >
          </el-table-column>
        </el-table>
      </el-dialog>

      <!-- 续当输入票号弹窗 -->
      <el-dialog
        title="请输入续当票的票号"
        :visible.sync="dialogXNumber"
        width="30%"
        :before-close="XNumberClose"
      >
        <el-input
          v-model="xNumberInput"
          placeholder="请输入票号"
          style="width: 50%"
        ></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="XNumberClose">取 消</el-button>
          <el-button type="primary" @click="sendXNumber">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 打印续当票 -->
      <el-dialog title="打票" :visible.sync="dialogFormVisible1" width="50%">
        <div id="print">
          <table width="100%">
            <tr>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ $store.state.name }}</td>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ printData.ticketnumber }}</td>
            </tr>
            <tr>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ printData.name }}</td>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ printData.name }}</td>
            </tr>
            <tr>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ Dprice }}</td>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ printData.pri + ".00" }}</td>
            </tr>
            <tr>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ Zprice }}</td>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ printData.xupri + ".00" }}</td>
            </tr>
            <tr>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ Lx }}</td>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ printData.lx + ".00" }}</td>
            </tr>
            <tr>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ ZCost }}</td>
              <td width="15%" class="tds"></td>
              <td width="35%" class="tds">{{ printData.rece + ".00" }}</td>
            </tr>
          </table>

          <table width="100%">
            <tr>
              <td width="15%" class="tds"></td>
              <td width="10%" class="tds">{{ years }}</td>
              <td width="10%" class="tds">{{ month }}</td>
              <td width="10%" class="tds">{{ Ydate }}</td>
              <td width="5%" class="tds"></td>
              <td width="5%" class="tds">{{ yearD }}</td>
              <td width="10%" class="tds">{{ monthD }}</td>
              <td width="10%" class="tds">{{ dateD }}</td>
              <td width="35%" class="tds"></td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="10%" class="tds"></td>
              <td width="10%" class="tds">{{ printData.ytdy > 0 ? "4.2" : "2.4" }}</td>
              <!-- {{((printData.xupri / printData.pri) * 100).toFixed(2)}} -->
              <td width="80%" class="tds"></td>
            </tr>
            <tr>
              <td width="10%" class="tds"></td>
              <td width="10%" class="tds">{{ printData.ytdy > 0 ? "0.3" : "0" }}</td>
              <!-- {{((printData.lx / printData.pri) * 100).toFixed(2)}} -->
              <td width="80%" class="tds"></td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="60%" class="tds"></td>
              <td width="10%" class="tds">{{ n }}</td>
              <td width="10%" class="tds">{{ y }}</td>
              <td width="10%" class="tds">{{ r }}</td>
              <td width="10%" class="tds"></td>
            </tr>
          </table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" v-print="'#print'">确定打票</el-button>
        </div>
      </el-dialog>

      <!-- 打印综合费票据 -->
      <el-dialog
        title="打印综合费收据"
        :visible.sync="dialogPrintPrices"
        width="50%"
        :before-close="handlePrintClose"
      >
        <div id="PrintZhf">
          <table width="100%">
            <tr>
              <td colspan="5" class="tdZhf"></td>
            </tr>
            <tr>
              <td width="28%" class="tdZhf"></td>
              <td class="tdZhf" width="10%">{{ Zhfyear }}</td>
              <td class="tdZhf" width="10%">{{ Zhfmonth }}</td>
              <td class="tdZhf" width="10%">{{ Zhfday }}</td>
              <td width="42%" class="tdZhf">{{ UpperCaseNum.xuname }}</td>
            </tr>
            <!-- <tr>
              <td colspan="5" class="tdZhf"></td>
            </tr> -->
            <tr>
              <td class="tdZhf"></td>
              <td class="tdZhf" colspan="2">
                {{ UpperCaseNum.ticketnumber + "-" + UpperCaseNum.name }}
              </td>
              <td colspan="2" class="tdZhf"></td>
            </tr>

            <tr>
              <td colspan="2" class="tdZhf"></td>
              <td class="tdZhf">
                {{ Number(UpperCaseNum.xupri) + Number(UpperCaseNum.lx) }}
              </td>
              <td colspan="2" class="tdZhf"></td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="30%" class="tdZhf"></td>
              <td class="tdZhf">
                <div class="UpperCase">
                  <span v-for="item in UpperCasePrice" :key="item._id">{{ item }}</span>
                </div>
              </td>
              <td width="25%" class="tdZhf"></td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="30%" class="tdZhf"></td>
              <td class="tdZhf">
                {{ Number(UpperCaseNum.xupri) + Number(UpperCaseNum.lx) }}
              </td>
              <td width="40%" class="tdZhf"></td>
            </tr>
          </table>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="handlePrintClose">取 消</el-button>
          <el-button type="primary" v-print="'#PrintZhf'">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 电子凭证弹窗 -->
      <el-dialog
        title="电子凭证"
        :visible.sync="dialogDzVoucher"
        width="70%"
        :before-close="DzVoucherClose"
      >
        <div class="DzVoucher">
          <VoucherTelement
            :UpdateData="DzVoucherData"
            :Xpiao="xpiao"
            :Udata="Udata"
            v-if="dialogDzVoucher"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="DzVoucherClose">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import VoucherTelement from "@/components/voucher/VoucherTelement.vue";
export default {
  name: "ces",
  components: {
    VoucherTelement,
  },
  data() {
    return {
      ACCESS_TOKEN: "", //get请求的ACCESS_TOKEN密钥
      items: "", //请求回来的数据
      dialogTableVisible: false,

      xudata: [], //续当记录
      id: "", //传过来的id
      ytdy: 0, //历史逾期天数

      openids: "查找中...",
      integral: "查找中...",

      opinion: "", //评估意见的值

      dialogFormVisible1: false,
      printData: "",
      Dprice: "", //大写典当金额
      Zprice: "", //大写综合费
      Lx: "", // 大写利息
      ZCost: "", //大写总付

      years: "",
      month: "",
      Ydate: "",

      yearD: "",
      monthD: "",
      dateD: "",

      n: "",
      y: "",
      r: "",

      titles: "", //当前典当行名字

      dialogVisible: false, //点击查看图片弹窗
      explain: "",
      dialogImageUrl: "", //被点击的图片地址

      dialogXNumber: false, //x续当票号弹窗
      xNumberInput: "", //输入的续当票号

      dialogPrintPrices: false, //打印当票弹窗

      UpperCasePrice: "", //综合费收据大写
      UpperCaseNum: {}, //综合费收据数据

      Zhfyear: "", //综合费收据 年
      Zhfmonth: "", //综合费收据 月
      Zhfday: "", //综合费收据 日
      dialogDzVoucher: false, //默认不显示
      DzVoucherData: {}, //点击的数据
      xpiao: "", //续当的票号
      Udata: {}, //电子续当凭证的数据
    };
  },
  methods: {
    //点击查看历史续当的按钮事件
    dialogTab() {
      (this.dialogTableVisible = !this.dialogTableVisible),
        //点击请求历史记录
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("yxus_record").where({ticketnumber:"' +
              this.items.ticketnumber +
              '"}).limit(1000).get()',
          })
          .then((rec) => {
            rec.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.xudata = rec.data.data.sort((a, b) =>
              a.enddate.localeCompare(b.enddate)
            );
          });
    },

    //点击图片查看大图
    dialog(e) {
      this.dialogImageUrl = e;
      this.dialogVisible = !this.dialogVisible;
    },

    //请求历史逾期天数
    getyus(piao) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").where({ticketnumber:"${piao}"}).get()`,
        })
        .then((r) => {
          r.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          //筛选出数组里该属性不为空的数据
          let test = r.data.data.filter((item) => {
            return item.ytdy !== undefined;
          });

          //拿到不为空的数组进行累加

          let str = "";
          for (let i in test) {
            str += test[i].ytdy;
            str += "+";
          }
          str = str.substring(0, str.length - 1);
          this.ytdy = eval(str) || 0;
        });
    },
    //获取客户openid
    getOpenid(cardid) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").where({idcard:"${cardid}"}).get()`,
        })
        .then((oid) => {
          oid.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          if (oid.data.data.length === 0) {
            return (this.openids = "未注册典当会员");
          }
          this.openids = "已注册会员";
        });
    },

    //查找客户积分
    getIntegral(cardnum) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("integral").where({userid:"${cardnum}"}).get()`,
        })
        .then((r) => {
          r.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (r.data.data.length == 0) {
            return (this.integral = 0);
          }
          this.integral = r.data.data[0].number || 0;
        });
    },

    oblur() {
      this.$confirm("是否确定修改评估意见/备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("add_data").doc("${this.id}").update({data:{opinion: "${this.opinion}"}})`,
            })
            .then((re) => {
              if (re.data.errcode == 0) {
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    //点击打票凭证，先弹出填写票号界面
    xNumber(event) {
      this.printData = event;

      if (event.xnumber !== undefined && event.xnumber == "") {
        // this.printData = event,
        this.dialogXNumber = !this.dialogXNumber;
      } else {
        //  this.printData = event,
        this.handleClick();
      }
    },
    //关闭续当票号界面
    XNumberClose() {
      (this.dialogXNumber = false), (this.printData = ""), (this.xNumberInput = "");
    },
    //确定填写续当票号按钮
    sendXNumber() {
      this.$confirm("是否使用该票号续当？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("yxus_record").doc("${this.printData._id}").update({data:{xnumber: "${this.xNumberInput}"}})`,
            })
            .then(() => {
              this.handleClick();
              (this.dialogXNumber = false), (this.xNumberInput = "");
            });
        })
        .catch(() => {
          (this.dialogXNumber = false),
            (this.xNumberInput = ""),
            this.$message({
              type: "info",
              message: "已取消",
            });
        });
    },

    //取消按钮

    handleClick() {
      this.dialogFormVisible1 = !this.dialogFormVisible1;

      // this.printData = event

      this.Dprice = this.digitUppercase(this.printData.pri);
      this.Zprice = this.digitUppercase(this.printData.xupri);
      this.Lx = this.digitUppercase(this.printData.lx);
      this.ZCost = this.digitUppercase(this.printData.rece);

      this.years = dayjs(this.printData.overdate).year();
      this.month = dayjs(this.printData.overdate).month() + 1;
      this.Ydate = dayjs(this.printData.overdate).date();

      this.yearD = dayjs(this.printData.enddate).year();
      this.monthD = dayjs(this.printData.enddate).month() + 1;
      this.dateD = dayjs(this.printData.enddate).date();

      this.n = dayjs().year();
      this.y = dayjs().month() + 1;
      this.r = dayjs().date();
    },

    //阿拉伯数字转大写

    digitUppercase(n) {
      let fraction = ["角", "分"];
      let digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      let unit = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"],
      ];
      let head = n < 0 ? "欠" : "";
      n = Math.abs(n);
      let s = "";
      for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(
          /零./,
          ""
        );
      }
      s = s || "整";
      n = Math.floor(n);
      for (let i = 0; i < unit[0].length && n > 0; i++) {
        let p = "";
        for (let j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
      }
      return (
        head +
        s
          .replace(/(零.)*零元/, "元")
          .replace(/(零.)+/g, "零")
          .replace(/^整$/, "零元整")
      );
    },

    //打印综合费收据
    PrintTicket(event) {
      // console.log(event)
      let price = Number(event.xupri) + Number(event.lx);
      this.dialogPrintPrices = !this.dialogPrintPrices;
      this.UpperCasePrice = this.digitUppercase(price).split("整")[0] + "零零";
      // console.log(this.digitUppercase(event.xupri).split('元整')[0] + '零零')
      // let test = this.digitUppercase(event.xupri).split('元整')[0]
      // console.log(test)

      this.UpperCaseNum = event;

      this.Zhfyear = dayjs(event.xuday).year();
      this.Zhfmonth = dayjs(event.xuday).month() + 1;
      this.Zhfday = dayjs(event.xuday).date();
    },
    //关闭打印综合费弹窗
    handlePrintClose() {
      this.dialogPrintPrices = false;
      this.UpperCasePrice = "";
      this.UpperCaseNum = {};
      this.Zhfyear = "";
      this.Zhfmonth = "";
      this.Zhfday = "";
    },

    //查看电子凭证
    LookVoucher(event) {
      //先请求数据库是否有该数据
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("voucher").where({ticketnumber:"${event.ticketnumber}",endDate:"${event.enddate}"}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (res.data.data.length >= 1) {
            // this.DzVoucherData.push(res.data.data)
            this.xpiao = res.data.data[res.data.data.length - 1].xpiao;
            this.Udata = res.data.data[res.data.data.length - 1];

            this.dialogDzVoucher = !this.dialogDzVoucher;
            this.DzVoucherData = event;

            return;
          }
          this.$message({
            showClose: true,
            message: "未查询到续当凭证，请先生成",
            type: "warning",
          });
        });
    },
    //关闭电子凭证
    DzVoucherClose() {
      this.dialogDzVoucher = false;
      this.DzVoucherData = {};
      (this.xpiao = ""), (this.Udata = {});
    },

    //查看电子凭证
    ViewImage(event, type) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("PZdata").where({pNumber:"${event}"}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (res.data.data.length == 0) {
            this.$message.error("未上传图片");
          } else {
            if (type == "当票") {
              this.dialogImageUrl = res.data.data[0].imag;
              this.dialogVisible = !this.dialogVisible;
              this.explain = "当票";
            } else if (type == "物品") {
              this.explain = "物品";
              this.dialogImageUrl = res.data.data[0].imags;
              this.dialogVisible = !this.dialogVisible;
            } else if (type == "检测") {
              this.explain = "检测报告";
              this.dialogImageUrl = res.data.data[0].reportImage;
              this.dialogVisible = !this.dialogVisible;
            } else if (type == "身份证正面") {
              this.explain = "身份证正面";
              this.dialogImageUrl = res.data.data[0].idcardz;
              this.dialogVisible = !this.dialogVisible;
            } else if (type == "身份证反面") {
              this.explain = "身份证反面";
              this.dialogImageUrl = res.data.data[0].idcardf;
              this.dialogVisible = !this.dialogVisible;
            } else {
              this.explain = "签约文件";
              this.dialogImageUrl = res.data.data[0].documents;
              this.dialogVisible = !this.dialogVisible;
            }
          }
        });
    },
    handleCloseView() {
      (this.dialogImageUrl = ""), (this.dialogVisible = false), (this.explain = "");
    },
  },

  created() {
    this.id = this.$route.query.id;
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");

    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();
  },

  mounted() {
    setTimeout(() => {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").doc("${this.id}").get()`,
        })
        .then((res) => {
          if (res.data.errcode !== 0) {
            return this.$notify.error({
              title: "错误提示",
              message: "密钥过期啦，请刷新页面",
            });
          }
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = res.data.data[0];
          this.opinion = res.data.data[0].opinion;
          this.getyus(res.data.data[0].ticketnumber);
          this.getOpenid(res.data.data[0].cardnumber);
          this.getIntegral(res.data.data[0].cardnumber);
        });

      this.titles = this.userData.title;
    }, 800);
  },
};
</script>
<style scoped>
.cont_heads {
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  border-radius: 10px;
}
.cont_tab {
  margin: 0 20px;
  padding: 10px 0;
}
.cont_cont {
  margin: 60px auto;
  width: 75%;
  /* height: 800px; */
  background-color: #ffffff;
  border-left: 1px solid #79797936;
  border-right: 1px solid #79797936;
  border-bottom: 1px solid #79797936;
}
.cont_content {
  width: 100%;
  height: 45px;
  background-color: #eeeeed;
  border: 1px solid #79797936;
  box-shadow: 0 0 9px 0 #00000044;
}
.conts_con {
  width: 98%;
  /* height: 91%; */
  border: 1px solid #79797936;
  margin: 10px auto;
  box-shadow: 0 0 9px 0 #00000044;
}
.conts_con h2 {
  margin: 10px 10px;
}
.cont_head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
}
.cont_hes {
  width: 95%;
  /* height: 600px; */
  background-color: #ffffff;
  border: 1px solid #79797936;
  box-shadow: 0 0 9px 0 #00000044;
  margin: 20px auto;
}

.con_os {
  width: 100%;
  /* margin: 5px auto; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.demo-image__preview {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px;
}
.con_fu {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.cont_head span {
  display: flex;
  flex-direction: row;
  align-items: center;
}

table {
  border-collapse: collapse;
}
td {
  /* width: 100%; */
  height: 40px;
  border: 1px solid black;
  font-size: 15px;
  text-align: center;
}

.tds {
  height: 16px;
  border: none;
  font-size: 13px;
  text-align: center;
}
.tdZhf {
  border: none;
  font-size: 15px;
}
.pgu_inpt {
  width: 100%;
}
.pgu_inpt >>> .el-input__inner {
  color: #ee3434;
  font-weight: bolder;
  font-size: 16px;
}
.con_xs {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.con_xs h3 {
  color: #e74949;
}
.UpperCase {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.UpperCase span {
  width: 7%;
  /* margin: 0 2px; */
  font-size: 15px;
  font-weight: bold;
}
</style>
